import React from "react"
import * as PropTypes from "prop-types";
import {CookiesProvider} from 'react-cookie'
import styled from "styled-components"

import Header from "../components/header/header"
import Footer from "../components/footer"

import "../style/reset.css"
import "../style/typography.css"

import CookiesConsent from "../components/cookies-consent";
import {FullWidthContainer, GlobalStyle, MaxWidthContainer} from "../style/itf-styled-components";
import Img from "gatsby-image/withIEPolyfill";

const Content = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const FeaturedImagePageLayout = ({
  page,
  featuredImage,
  theme,
  withCookiesConsent,
  children
}) => {

  return (
    <>
      <GlobalStyle/>
      <FullWidthContainer
        css={`
          @media (max-width: ${props => props.theme.mobileWidth}) {
            padding-top: 45px;
          }
        `}
      >
        <Header page={page}/>

        <Img
          css={`
              width: 100%;
              height: 30vw;
            `}
          fluid={featuredImage.childImageSharp.fluid}
          objectPosition="50% top"
        />

        <MaxWidthContainer
          css={`
              padding: 30px 25px 60px 25px;
            `}
        >
          <Content>{children}</Content>
        </MaxWidthContainer>

        <Footer/>

        {withCookiesConsent && (
          <CookiesProvider>
            <CookiesConsent/>
          </CookiesProvider>
        )}
      </FullWidthContainer>
    </>
  );
};

FeaturedImagePageLayout.defaultProps = {
  withCookiesConsent: true,
};

FeaturedImagePageLayout.propTypes = {
  page: PropTypes.string.isRequired,
  withCookiesConsent: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default FeaturedImagePageLayout
